import type { ImageModel } from '@rocco/types/image-model';
import type { TileableModel } from '@rocco/ui/tile-shared/view-models/tile';

interface ProfessionalLogoTileViewModel {
    image: ImageModel;
    background: string;
}

export interface ProfessionalTileViewModel {
    id: number;
    title: string;
    image: ImageModel;
    logo: ProfessionalLogoTileViewModel | null;
    category: string;
    services: string[];
    link: string;
    location: string;
    content?: string;
    hasAwards: boolean;
    memberSince: number | null;
    video?: string[];
    /** Product category URL segments for products sold by this professional */
    productCategorySegments?: string[];
    /**
     * The profile hero's full-size first-banner rendition, warmed on tile
     * hover (alongside the loader prefetch) so the tile→hero morph lands on
     * a decoded image instead of waiting on the largest asset of the page.
     */
    heroImageSrc?: string | null;
}

export const isProfessionalTileViewModel = (
    model: TileableModel,
): model is ProfessionalTileViewModel =>
    model && 'category' in model && 'memberSince' in model;
